<script setup lang="ts">
import { Color, ColorSemantic } from '@previo/codebooks'
import { computed } from 'vue'
import { useColor } from '../../composables/helpers/color'
import PTextLink from '../typography/links/PTextLink.vue'
import type { PMaxLines } from '../typography/types'
import { PLinkTarget } from './types'

type Props = {
  text?: null | string
  color?: ColorSemantic.TEXT_LINK | Color.PRIMARY | Color.GREY_600 | Color.INFO | Color.WHITE
  url: string
  target?: null | PLinkTarget
  maxLines?: null | PMaxLines
  ellipsis?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  color: ColorSemantic.TEXT_LINK,
  target: PLinkTarget.SELF,
  maxLines: null,
  ellipsis: false,
})

const { getCssVarByColor } = useColor()

const linkColor = computed<string>(() => getCssVarByColor(props.color))
</script>

<template>
  <a
    :href="url"
    class="ds-link"
    :style="{ '--link-color': linkColor }"
    :target="target ?? undefined"
  >
    <slot name="default">
      <p-text-link :text="text" :color="color" :max-lines="maxLines" :ellipsis="ellipsis" />
    </slot>
  </a>
</template>

<style scoped lang="scss">
.ds-link {
  text-decoration: none;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--link-color);
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  &:hover::after {
    opacity: 1;
  }
}
</style>
